import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SupervisorContact } from '@core/models/supervisor-contact.model';
import { Observable, shareReplay } from 'rxjs';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class SupervisorService {
  private readonly environment = inject(EnvironmentService);
  private readonly http = inject(HttpClient);

  private readonly API_URL = this.environment.getApiUrl();

  // Cache for the resolved supervisor
  private cachedSupervisor$: Observable<SupervisorContact> | null = null;

  /**
   * Get the direct supervisor of the currently authenticated internal user
   * (e.g. a Comercial's Jefe de Equipo). The backend may not always be able
   * to resolve one, in which case it responds with 404.
   * @returns Observable with the supervisor contact data
   */
  getMySupervisor(): Observable<SupervisorContact> {
    return this.http.get<SupervisorContact>(`${this.API_URL}v1/users/my-supervisor`);
  }

  /**
   * Get the supervisor with caching.
   * Caches the response to avoid multiple API calls during the session.
   * @returns Observable with the supervisor contact data
   */
  getCachedSupervisor(): Observable<SupervisorContact> {
    if (!this.cachedSupervisor$) {
      this.cachedSupervisor$ = this.getMySupervisor().pipe(shareReplay(1));
    }
    return this.cachedSupervisor$;
  }

  /**
   * Clear the cache to force a fresh fetch on next call.
   */
  clearCache(): void {
    this.cachedSupervisor$ = null;
  }
}
